import React, { createContext } from 'react';

export interface IContext {
    filterProject: string[];
    filterStatus?: number;
}

export const SmxGlobalFilterContext = createContext<IContext>({
    filterProject: [],
});

interface IPermissionProvider extends IContext {
    children: React.ReactNode;
}

const GlobalFilterProvider: React.FC<IPermissionProvider> = ({ filterProject, children }) => {
    return <SmxGlobalFilterContext.Provider value={{ filterProject }}>{children}</SmxGlobalFilterContext.Provider>;
};

export default GlobalFilterProvider;
